import React, {Component} from "react";
import {Button} from "primereact/button";
import Capacity from "./CapacityView";

export default class CapacityContainer extends Component {
    render() {
        var headerCapacity =
            <div className="p-clearfix" style={{'lineHeight': '1.87em'}}>
                <Button icon="pi pi-refresh" style={{'float': 'right'}}/>
            </div>;

        return <Capacity headerCapacity={headerCapacity}/>

    }
};